module.exports = __webpack_public_path__ + "img/研发领域banner.37757c3b.png";